(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["evernext-product-story"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-evernext-story-source]';
  const hasContent = (nodes) => nodes.some((node) => node.nodeType === 1 || (node.textContent || '').trim());
  const enhance = (source) => {
    if (source.dataset.evernextEnhanced) return;
    const headings = Array.from(source.querySelectorAll('h2, h3'));
    // Nested rich layouts stay intact rather than being guessed at or split.
    if (headings.some((heading) => heading.parentElement !== source)) return;
    const intro = [];
    const groups = [];
    let current = null;
    Array.from(source.childNodes).forEach((node) => {
      const isHeading = node.nodeType === 1 && /^(H2|H3)$/.test(node.tagName) && node.textContent.trim();
      const label = node.nodeType === 1 && node.tagName === 'P' ? node.firstElementChild : null;
      const safetyLabel = label && /^(STRONG|B)$/.test(label.tagName) && /^(care(?:\s*(?:&|and)\s*safety)?|safety|warnings?)\s*:/i.test(label.textContent.trim());
      if (isHeading || safetyLabel) {
        current = { heading: isHeading ? node : null, label: safetyLabel ? label.textContent.trim().replace(/:\s*$/, '') : '', nodes: [] };
        groups.push(current);
        if (safetyLabel && !isHeading) current.nodes.push(node);
      } else {
        (current ? current.nodes : intro).push(node);
      }
    });
    if (!groups.length || groups.some((group) => !hasContent(group.nodes))) return;
    const fragment = document.createDocumentFragment();
    if (hasContent(intro)) {
      const lead = document.createElement('div');
      lead.className = 'evernext-product-story__lead hdt-rte';
      intro.forEach((node) => lead.appendChild(node.cloneNode(true)));
      fragment.appendChild(lead);
    }
    const items = document.createElement('div');
    items.className = 'evernext-product-story__items';
    groups.forEach((group) => {
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      if (group.heading) summary.appendChild(group.heading.cloneNode(true));
      else summary.textContent = group.label;
      const title = summary.textContent.toLowerCase();
      const answerText = group.nodes.map((node) => node.textContent || '').join(' ').toLowerCase();
      const hasImportantLimit = /\bnot included\b|\brequires? assembly\b|\bassembly required\b|\bsupplied unassembled\b|\bone random\b|\brandomly supplied\b|\bcannot be selected\b|\bnot all\b|\beach purchase includes only\b|\bsold individually\b/.test(answerText);
      if (/includ|safety|warning|care/.test(title) || hasImportantLimit) details.open = true;
      const answer = document.createElement('div');
      answer.className = 'evernext-product-story__answer hdt-rte';
      group.nodes.forEach((node) => answer.appendChild(node.cloneNode(true)));
      details.append(summary, answer);
      items.appendChild(details);
    });
    fragment.appendChild(items);
    // Commit only after building the entire replacement; no source is discarded.
    source.replaceChildren(fragment);
    source.classList.remove('evernext-product-story__lead', 'hdt-rte');
    source.dataset.evernextEnhanced = 'true';
  };
  const initialize = (root) => {
    root.querySelectorAll(selector).forEach((source) => {
      try { enhance(source); } catch (_) { /* The original server-rendered description remains readable. */ }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
